import { Transform } from 'class-transformer';
import { dateTransform } from '../utils/helper';

export class Asl {
    id!: number;
    name!: string;
    province?: string;
    country?: string;
    zipcode?: string;
    districtcode?: string;
    aslcode?: string;
    @Transform(dateTransform)
	insdate!: Date;
	@Transform(dateTransform)
    moddate!: Date;
}
